import { render, staticRenderFns } from "./finish_withdrawal.vue?vue&type=template&id=16ec6014&scoped=true&"
var script = {}
import style0 from "./finish_withdrawal.vue?vue&type=style&index=0&id=16ec6014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec6014",
  null
  
)

export default component.exports